<template>
  <div>
    <div class="main-content card p-1" v-if="loader === 100">
      <div class="row">
        <div class="col-md-12">
          <h6>Dados gravados em {{ totem.created_at_f }}</h6>
          <h6 v-show="totem.updated_at">Última edição em {{ totem.updated_at_f }}</h6>
        </div>
        <div class="col-md-12">
          <label>Unidade</label>
          <input type="text" class="form-control" v-model="totem.unidade.nome" disabled />
        </div>
        <div class="col-md-12">
          <label>Nome</label>
          <input type="text" class="form-control" v-model="totem.nome" disabled />
        </div>
        <div class="col-md-4">
          <label>Nome da impressora</label>
          <input type="text" class="form-control" v-model="totem.impressora" disabled/>
        </div>
        <div class="col-md-4">
          <label>Tempo da mensagem (ms):</label>
          <input type="number" min="0" class="form-control" v-model="totem.timeout" disabled />
        </div>
        <div class="col-md-4">
          <label>Cor do fundo</label>
          <input type="color" class="form-control" v-model="totem.cor" disabled />
        </div>
        <div class="col-md-4">
          <label>Arredondamento</label>
          <label class="ml-5">{{ totem.arredondamento }}px</label>
          <input type="range" v-model="totem.arredondamento" class="form-control" step="1" min="0" max="50" disabled />
        </div>
        <div class="col-md-4">
          <label>Tamanho da fonte do header</label>
          <label class="ml-5">{{ totem.fonte_header }}vh</label>
          <input type="range" v-model="totem.fonte_header" class="form-control" step="0.1" min="0" max="12" disabled />
        </div>
        <div class="col-md-4">
          <label>Tamanho da fonte do relógio</label>
          <label class="ml-5">{{ totem.fonte_relogio }}vh</label>
          <input type="range" v-model="totem.fonte_relogio" class="form-control" step="0.1" min="0" max="12" disabled />
        </div>
        <div  :class="totem.disposicao === 2 ? 'col-md-3' : 'col-md-4'">
          <label>Disposição</label>
          <select class="form-control" v-model="totem.disposicao" disabled >
            <option :value="'0'">Bloco</option>
            <option :value="1">Lista</option>
            <option :value="2">Agendamento</option>
          </select>
        </div>
        <div :class="totem.disposicao === 2 ? 'col-md-3' : 'd-none'">
          <br />
          <label
            class="btn btn-primary w-100"
            v-bind:class="{ disabled: !totem.biometria }"
            style="cursor: pointer"
          >
            <input type="checkbox" v-model="totem.biometria" class="d-none" disabled />
            Biometria
          </label>
        </div>
        <div :class="totem.disposicao === 2 ? 'col-md-3' : 'col-md-4'">
          <br />
          <label
            class="btn btn-primary w-100"
            v-bind:class="{ disabled: !totem.degrade }"
            style="cursor: pointer"
          >
            <input type="checkbox" v-model="totem.degrade" class="d-none" disabled />
            Degradê
          </label>
        </div>
        <div :class="totem.disposicao === 2 ? 'col-md-3' : 'col-md-4'">
          <br />
          <label
            class="btn btn-primary w-100"
            v-bind:class="{ disabled: !totem.header }"
            style="cursor: pointer"
          >
            <input type="checkbox" v-model="totem.header" class="d-none" disabled />
            Header
          </label>
        </div>
        <div :class="totem.header ? 'col-md-3' : 'd-none'">
          <br />
          <label>Cor do fundo do header</label>
          <input type="color" class="form-control" v-model="totem.background_header" disabled />
        </div>
        <div :class="totem.header ? 'col-md-3' : 'd-none'">
          <br />
          <label>Cor do texto do header</label>
          <input type="color" class="form-control" v-model="totem.color_header" disabled />
        </div>
        <div :class="totem.header ? 'col-md-3' : 'd-none'">
          <br />
          <br />
          <label
            class="btn btn-primary w-100"
            v-bind:class="{ disabled: !totem.relogio }"
            style="cursor: pointer"
          >
            <input type="checkbox" v-model="totem.relogio" class="d-none" disabled />
            Relógio
          </label>
        </div>
        <div class="col-md-12">
          <label>URL para impressão</label>
          <input type="text" class="form-control" v-model="totem.url_impressao" disabled/>
        </div>
        <div :class="totem.header ? 'col-md-12' : 'd-none'">
          <label>Mensagem central</label>
          <textarea
            class="form-control"
            rows="5"
            v-model="totem.mensagem_central"
            disabled
          ></textarea>
        </div>
        <div class="col-md-4">
          <label>ID central</label>
          <input type="text" class="form-control" v-model="totem.id" disabled />
        </div>
        <div class="col-md-4">
          <label>ID original</label>
          <input type="text" class="form-control" v-model="totem.original_id" disabled />
        </div>
        <div class="col-md-4">
          <label>Status</label>
          <input type="text" class="form-control" v-model="totem.ativo" disabled />
        </div>
        <div class="col-md-6 text-left d-flex align-items-end">
          <h5>Última sincronização realizada em {{ totem.sincronizacao_f }}</h5>
        </div>
        <div class="col-md-6 text-right">
          <hr />
          <router-link to="/totens" class="btn btn-back">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
        </div>
      </div>
    </div>
    <div class="row justify-content-center mt-3" v-else>
      <div class="col-10 text-center">
        <div class="progress">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            :style="'width: ' + loader + '%;'"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <b style="font-size: 14pt">Carregando</b><br />
        <b style="font-size: 16pt; line-height: 12pt">{{ loader }}%</b>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      loader: 0,
      totem: {},
    };
  },
  computed: {},
  methods: {
    getTotem: function (id) {
      const self = this;
      const api = self.$store.state.api + "totens/" + id + '?with[]=unidade';

      axios
        .get(api)
        .then((response) => {
          if(response.data.data[0])
          {
            self.totem = response.data.data[0];
            
            self.totem.ativo = self.totem.ativo ? "Ativo" : "Inativo";
            
            self.setLoader(50);
          }else{
            this.$router.push("/no-item");
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    setLoader: function (qtd) {
      const self = this;

      let load = 0;
      let interval = setInterval(function () {
        self.loader++;
        load++;

        if (load == qtd) {
          clearInterval(interval);
        }
      }, 15);
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.setLoader(50);

    if (id) {
      self.getTotem(id);
    } else {
      self.setLoader(50);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>